import React from 'react';
import uniqueId from 'lodash.uniqueid';

export default function OrderingTableItemVariants (props) {
  const closeBtn = (
    <tr className="ordering-variant-table__tr-close">
      <td colSpan="2">
        <button
          type="button"
          className="ordering-variant-table__close-btn link-expand"
          onClick={props.handleClickClose}
        >
          Close
        </button>
      </td>
    </tr>
  );

  let tableContent;
  if (props.products.length > 0) {
    tableContent = (
      <React.Fragment>
        <thead>
          <tr className="ordering-variant-table__tr-heading">
            <th>Product name</th>
            <th>Product number</th>
          </tr>
        </thead>
        <tbody>
          {props.products.map (item => (
            <tr key={uniqueId ()}>
              <td>{item.Name}</td>
              <td>{item.Number}</td>
            </tr>
          ))}
          {closeBtn}
        </tbody>
      </React.Fragment>
    );
  } else {
    tableContent = (
      <tbody>
        <tr className="ordering-variant-table__tr-heading">
          <td>
            <a href="/contacts-and-locations/" target="_blank">
              Please contact our customer service to get a custom offer
            </a>
          </td>
        </tr>
        {closeBtn}
      </tbody>
    );
  }

  return (
    <table className="ordering-variant-table">
      {tableContent}
    </table>
  );
}
